import { useRouter } from 'next/router'

import { COBRANDING_PARTNER_COOKIE_KEY } from '@/constants'
import Cookies from 'js-cookie'

import { CobrandingNewPartners } from './useGetCobrandingNewPartners'

export const useCreditKarmaHeader = () => {
  const { asPath } = useRouter()

  const pathnameWithoutQuery = asPath.split('?')[0]
  const isValidAudiencePath = ['/life/credit-karma-members/'].includes(
    pathnameWithoutQuery
  )

  if (isValidAudiencePath) {
    Cookies.set(
      COBRANDING_PARTNER_COOKIE_KEY,
      CobrandingNewPartners.CreditKarma,
      { expires: 365 }
    )
  }

  return isValidAudiencePath
}
